<template>
  <div style="display: flex">
    <a
      class="btn btn-sm btn-clean btn-icon btn-icon-sm"
      @click.prevent="toggleCheck"
      title="تایید تراکنش و اضافه کردن به تراکنش های سامانه"
    >
      <i class="fa fa-check"></i>
    </a>
  </div>
</template>

<script>
import Vue from "vue";
import { accountingService, starShopAccountingService } from "../../../common/api.service";

export default Vue.extend({
  props: {
    row: {
      required: true,
    },
    index: {
      required: true,
    },
    datatable: {
      required: true,
    },
  },
  methods: {
    toggleCheck() {
      const payload = {
        hashid: this.row.id,
        transaction_type: this.row.type_code
      }
      starShopAccountingService.addToTransactions(payload).then(
        (response) => {
          this.toastr.success(response.data.message);
          this.datatable.reload()
        },
        (error) => {
          this.toastr.error(
            error.response.data.message || i18n.t("message.an_error_occurred")
          );
        }
      );
    },
  },
});
</script>

<style scoped>
.checked {
  color: green;
}
</style>